import "@/styles/main.scss";
import "@mdi/font/css/materialdesignicons.css";

import Vue from "vue";

import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
Sentry.init({
  dsn: process.env.VUE_APP_UBIC_GLITCHTIP_DSN
});

import App from "./App.vue";

import "viewerjs/dist/viewer.css";
import VueViewer from "v-viewer";
Vue.use(VueViewer);

// @ts-ignore
import JsonTree from "vue-json-tree";
Vue.component("json-tree", JsonTree);

import "vue-wysiwyg/dist/vueWysiwyg.css";
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
  hideModules: { image: true },
  forcePlainTextOnPaste: true
});

import Buefy from "buefy";
Vue.use(Buefy, {
  defaultDayNames: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
  defaultMonthNames: [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь"
  ],
  defaultFirstDayOfWeek: 1
});
// import 'buefy/dist/buefy.css'

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

Vue.use(PerfectScrollbar);

// import vSelect from 'vue-select';
// Vue.component('v-select', vSelect)

// @ts-ignore
import { Plugin } from "vue-fragment";
Vue.use(Plugin);

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);

import "./registerServiceWorker";
import router from "./router";
import store from "./store";

import { UbicPlugin } from "./core";
Vue.use(UbicPlugin, { store });

import moment from "moment";
import "moment/locale/ru";
moment.locale("ru", {
  week: {
    // @ts-ignore
    dow: 1
  }
});
Vue.filter("weekDay", (value: string) => {
  const _mapper: any = {
    "1": "пн",
    "2": "вт",
    "3": "ср",
    "4": "чт",
    "5": "пт",
    "6": "сб",
    "7": "вс"
  };
  return _mapper[value + ""];
});
Vue.filter("date", (value: string | Date, format: any, to: string[]) => {
  if (value) {
    if (to) {
      // @ts-ignore
      return moment(value)[to[0]](to[1], to[2]).format(format || "DD.MM.YYYY");
    }
    return moment(value).format(format || "DD.MM.YYYY");
  }
});
Vue.filter("time", (value: string | Date, format: any, to: string[]) => {
  if (value) {
    if (to) {
      // @ts-ignore
      return moment(value, "HH:mm:ss")[to[0]](to[1], to[2]).format(format || "HH:mm:ss");
    }
    return moment(value, "HH:mm:ss").format(format || "HH:mm:ss");
  }
});
Vue.filter("fixMonthDay", (value: string | Date, format: any) => {
  let _today: any = moment();
  if (moment().date() >= 25) {
    _today = _today.add("month", 1);
  }
  const _cur_month: any = _today.month();
  const _value_month: any = moment(value).month();
  let _value: any = value;
  if (_value_month < _cur_month) {
    _value = moment(_today).startOf("month");
  } else if (_value_month > _cur_month) {
    _value = moment(_today).endOf("month");
  }
  return moment(_value).format(format || "DD.MM.YYYY");
});
Vue.filter(
  "fixMonthDayByBase",
  (value: string | Date, base_value: string | Date, format: any) => {
    const _today: any = moment(base_value || value);
    const _cur_month: any = _today.month();
    const _value_month: any = moment(value).month();
    let _value: any = value;
    if (_value_month < _cur_month) {
      _value = moment(_today).startOf("month");
    } else if (_value_month > _cur_month) {
      _value = moment(_today).endOf("month");
    }
    return moment(_value).format(format || "DD.MM.YYYY");
  }
);
Vue.filter(
  "fixAnyMonthDay",
  (value: string | Date, base_value: string | Date, format: any) => {
    const _today: any = moment(base_value).startOf("month");
    const _cur_month: any = _today.endOf("week").month();
    const _value_month: any = moment(value).month();
    let _value: any = value;
    if (_value_month < _cur_month) {
      _value = moment(_today).startOf("month");
    } else if (_value_month > _cur_month) {
      _value = moment(_today).endOf("month");
    }
    return moment(_value).format(format || "DD.MM.YYYY");
  }
);

import Combobox from "./components/Controls/Combobox.vue";
Vue.component("b-combobox", Combobox);

import StatusSelect from "./components/Controls/StatusSelect.vue";
Vue.component("b-status-select", StatusSelect);

import ProductVariantSelect from "./components/Controls/ProductVariantSelect.vue";
Vue.component("b-product-variant-select", ProductVariantSelect);

import ContactsEditor from "./components/Controls/ContactsEditor.vue";
Vue.component("b-contacts-editor", ContactsEditor);

import numeral from "numeral";
// import numFormat from 'vue-filter-number-format';

const numFormat = (numeral: any) => {
  /**
   * apply a Numeral.js formatting string to an input value
   * @param {Number} val input value to be changed
   * @param {String} [format='0,0'] Numeral.js format string
   * @return {String} formatted output string
   */
  return (val: any, format = "0,0") => {
    val = Math.round(val * 10000) / 10000;
    return numeral(val).format(format);
  };
};
Vue.filter("numFormat", numFormat(numeral));
Vue.filter("targetLink", (value: string) => {
  let tab = "";
  if (value && value.indexOf("#") > -1) {
    const _split = value.split("#");
    value = _split[0];
    tab = _split[1];
  }
  if (tab != "") {
    tab = "?tab=" + tab;
  }
  if (value && (value.startsWith("d:") || value.startsWith("s:"))) {
    const _parts = value.split(":");
    return "/" + _parts[1] + "/details/" + value + tab;
  } else {
    return value + tab;
  }
});
const _val_mapper: any = {
  init: "Создано",
  confirmed: "Подрвеждено"
};
Vue.filter("toType", (value: any, type: string) => {
  switch (type) {
    case "date":
      value = value ? moment(value).format("DD.MM.YYYY") : "";
      break;
    case "timestamp":
      value = moment(value).format("DD.MM.YYYY hh:mm:ss");
      break;
    case "relation":
      value = value.name;
      break;
    case "polyrel":
      value = value.name;
      break;
    case "id":
      value = value.name;
      break;
    case "string":
      value = value in _val_mapper ? _val_mapper[value] : value;
      break;
  }
  return value;
});

import InfoColumnItem from "./components/Details/InfoColumnItem.vue";
import InfoColumnContacts from "./components/Details/InfoColumnContacts.vue";
Vue.component("b-details-info-item", InfoColumnItem);
Vue.component("b-details-info-contacts", InfoColumnContacts);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
